import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  fiat: {
    defaultMessage: 'Cash only',
  },
  cashAndCrypto: {
    defaultMessage: 'Cash and Crypto',
  },
  crypto: {
    defaultMessage: 'Crypto only',
  },
});
